import { getCombinedMessages } from '../../../redux/actions/messagesActions.js';
import selectors from '../../../selectors/selectors.js';
import { store } from '../../../redux/lib/configureStore.js';
import { action } from '../../../lib/actionHelpers.js';
import inboxFolderSelector from './inboxFolderSelector.js';
import setQuery from '../../../lib/setQuery.js';
import { putMessageStatus } from '../../../redux/actions/leadModalActions.js';
import inboxFoldersSelector from 'screens/inbox/store/inboxFoldersSelector.js';

export const getInboxCombinedMessages = ({ folder, count, eventId, eventType }, callback) => {
  const state = store.getState();
  const selectServiceProviderFromURL = selectors.selectServiceProviderFromURL(state);
  const userId = selectors.filteredUserId(state);
  const locationId = state.ui.filters.locationId;
  const readOrUnread = state.ui.filters.showReadMessages ? 'read' : 'unread';
  const offset = selectors.folderOffset(folder.id)(state);
  return getCombinedMessages(
    {
      serviceProviderId: selectServiceProviderFromURL,
      uid: userId,
      readOrUnread: readOrUnread,
      folder,
      count,
      eventId,
      eventType,
      locationId,
      offset: offset,
    },
    callback
  );
};

export const getInboxMessages = (opts = {}) => {
  const callback = opts.callback || (() => {});
  const state = store.getState();
  const folders = inboxFoldersSelector(state);
  const folderId = opts.folderId || inboxFolderSelector(state);
  const matchedFolder = folders.find((n) => n.id === folderId);
  const offset = selectors.folderOffset(folderId)(state);
  const selectServiceProviderFromURL = selectors.selectServiceProviderFromURL(state);
  if (!selectServiceProviderFromURL || !matchedFolder) {
    return;
  }
  const loader = offset > 0 ? 'inboxSetPaginationLoading' : 'inboxSetSidebarLoading';
  action(loader, true);
  const doneHandler = () => {
    action(loader, false);
    if (callback) {
      callback();
    }
  };
  getInboxCombinedMessages({ folder: matchedFolder, count: opts.count, eventId: opts.eventId, eventType: opts.eventType }, doneHandler);
};

export const getInboxMessageCounts = ({ folderId }) => {
  return getInboxMessages({ folderId, count: true });
};

export const getAllInboxMessages = () => {
  const state = store.getState();
  const folders = inboxFoldersSelector(state);
  folders.forEach((folder) => getInboxMessages({ folderId: folder.id }));
};

export const setInboxMessageStatus = (message, statusId) => {
  const state = store.getState();
  const folder = inboxFolderSelector(state);

  setQuery({ eid: null, etype: null, type: null, modal: null, tab: null, filter: null });
  const payload = {
    status_id: statusId,
    event_type: message.type,
    is_read: message.message.lead_id !== null ? message.isRead : statusId === '1' ? '0' : '1',
  };
  const reduxPayload = {
    ...message.message,
    ...payload,
    currentFilterStateId: folder === 'inbox' ? '1' : '3',
    leadId: message.id,
  };

  putMessageStatus(message.id, payload, () => {
    action('PATCH_MESSAGE_FOR_INBOX', reduxPayload);
  });
};
